import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type CreateNotePayload = {
  studentId: string;
  content: string;
  date: number;
};

type CreateNoteState = {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: CreateNoteState = {
  loading: false,
  error: false,
  errorMessage: '',
  data: null,
};

export const createNote = createAsyncThunk<unknown, CreateNotePayload>(
  'createNote',
  async ({ studentId, content, date }) => {
    if (!studentId) {
      throw new Error('Missing student ID.');
    }
    const { data: response } = await api.post(
      `/api/coaches/me/students/${studentId}/notes`,
      {
        content,
        date,
      }
    );
    return response;
  }
);

const createNoteSlice = createSlice({
  name: 'createNote',
  initialState,
  reducers: {
    resetCreateNote: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createNote.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(createNote.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(createNote.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.error.message ?? 'Failed to create note.';
    });
  },
});

export const { resetCreateNote } = createNoteSlice.actions;
export default createNoteSlice.reducer;
